import { render, staticRenderFns } from "./chatContentGroup.vue?vue&type=template&id=563ca899&scoped=true"
import script from "./chatContentGroup.vue?vue&type=script&lang=js"
export * from "./chatContentGroup.vue?vue&type=script&lang=js"
import style0 from "./chatContentGroup.vue?vue&type=style&index=0&id=563ca899&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563ca899",
  null
  
)

export default component.exports